import _regeneratorRuntime from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/builds/adn/dashboard-vuejs/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// For User Roles selecting (including Network/CompanyUserAttributes)
var ROLE_ORG = ['admin', 'publisher', 'advertiser', 'publisher_readonly', 'advertiser_readonly', 'bd', 'fae'];
var ROLE_ALL = ROLE_ORG.concat(['network_viewable']);

// For Roles Checking & Route displaying
var rolesFAE = ['admin', 'fae'];
var rolesBD = ['admin', 'fae', 'bd'];
var rolesPublisher = ['admin', 'fae', 'bd', 'publisher', 'publisher_readonly'];
var rolesAdvertiser = ['admin', 'fae', 'advertiser', 'advertiser_readonly'];
var rolesPublisherWritable = ['admin', 'fae', 'bd', 'publisher'];
var rolesAdvertiserWritable = ['admin', 'fae', 'advertiser'];
var rolesUserTemplate = _toConsumableArray(new Set(rolesFAE.concat(rolesAdvertiser)));
var rolesUserInner = ['admin', 'fae', 'bd', 'advertiser', 'publisher', 'advertiser_readonly', 'publisher_readonly', 'network_viewable'];
var rolesUserAll = ['admin', 'fae', 'bd', 'advertiser', 'publisher', 'advertiser_readonly', 'publisher_readonly', 'network_viewable', 'user'];
var bcryptjs = require('bcryptjs');
function generateHashedPassword(_x) {
  return _generateHashedPassword.apply(this, arguments);
}
function _generateHashedPassword() {
  _generateHashedPassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(password) {
    var salt;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return bcryptjs.genSalt();
        case 2:
          salt = _context.sent;
          _context.next = 5;
          return bcryptjs.hash(password, salt);
        case 5:
          return _context.abrupt("return", _context.sent);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _generateHashedPassword.apply(this, arguments);
}
export { ROLE_ALL, ROLE_ORG, rolesFAE, rolesBD, rolesPublisher, rolesPublisherWritable, rolesAdvertiser, rolesAdvertiserWritable, rolesUserTemplate, rolesUserInner, rolesUserAll, generateHashedPassword };